import { useI18n } from 'next-localization';
import BaseSkeleton from 'components/Generic/BaseSkeleton';
import classNames from 'classnames';
import CustomScroll from 'components/Functional/CustomScroll';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { useState } from 'react';

type Data = {
  daysatDiscount: number;
  daysatPremium: number;
  label: string;
  period: string;
};

type Props = {
  data: Array<Data>;
  isFetching: boolean;
  className: string;
};

const FundDetailsPremiumDiscountLineChartTable = ({ data, isFetching, className }: Props) => {
  const { t } = useI18n();
  const deviceType: string = useWindowDimensions();
  const [gradientPosition, setGradientPosition] = useState('gradient-right');
  return (
    <div className={className}>
      {isFetching ? (
        <BaseSkeleton height="120px" />
      ) : data && data.length !== 0 ? (
        <>
          <div className="position-relative">
            <div
              id="premiumDiscountLineChartWrapper"
              className={classNames('abrdn-table', {
                scrollable: deviceType === 'mobile',
                [gradientPosition]: gradientPosition,
              })}
            >
              <table
                id="premiumDiscountLineChartTable"
                className="not-striped"
                tabIndex="0"
                aria-label={t('fundDetailsPremiumDiscountDataTableTitle')}
              >
                <thead>
                  <tr>
                    <th scope="col" />
                    {data.map((period) => (
                      <th key={period.period} scope="col">
                        {period.period}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">{t('fundDetailsPremiumDiscountDaysTradedAtPremium')}</th>
                    {data.map((period) => (
                      <td key={period.period}>{period.daysatPremium}</td>
                    ))}
                  </tr>
                  <tr>
                    <th scope="row">{t('fundDetailsPremiumDiscountDaysTradedAtDiscount')}</th>
                    {data.map((period) => (
                      <td key={period.period}>{period.daysatDiscount}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {deviceType === 'mobile' && (
            <CustomScroll
              wrapperId="premiumDiscountLineChartWrapper"
              tableId="premiumDiscountLineChartTable"
              changeGradientPosition={setGradientPosition}
            />
          )}
        </>
      ) : (
        <div className="body-default">{t('noResultsMessage')}</div>
      )}
    </div>
  );
};

export default FundDetailsPremiumDiscountLineChartTable;
